/**
 * Copyright (c) 2026, CheckPlus Limited
 */

/**
 * The donation itself, before fees (CP-386), as the backend reads it.
 * - Not covering fees: `amount`, which is what's charged. Its `baseAmount`
 *   can be stale: older edits changed only `amount`.
 * - Covering fees: `baseAmount`. A covered first payment stores the total
 *   with fees in `amount`. Older covered payments without `baseAmount`:
 *   `originalDonationAmount`, or `net` (the organization receives the
 *   donation in full).
 */
export const donationOf = (payment) => {
  if (!payment.coverFee) return payment.amount;
  if (payment.baseAmount != null) return payment.baseAmount;
  return payment.originalDonationAmount != null
    ? payment.originalDonationAmount
    : payment.net;
};
